$.validator.addMethod(
	'currency',
	(value: string) => {
		return /^\$?([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/.test(value);
	},
	'Please enter a valid price'
);

$.validator.addMethod(
	'currency_max',
	(value: string, _, max: number) => {
		const number = Number(value.replace(/[^0-9.]/g, ''));
		return number <= max;
	},
	(max: number) => `Please enter a price less than $${max.toString()}`
);

$.validator.addMethod(
	'currency_min',
	(value: string, element, min: number) => {
		if (element.getAttribute('required')) {
			const number = Number(value.replace(/[^0-9.]/g, ''));
			return number > min;
		}
		return true;
	},
	(min: number) => `Please enter a price of more than $${min.toString()}`
);

$.validator.addMethod(
	'postcode',
	(value: string) => {
		return /^\d{4}$/.test(value);
	},
	() => 'Please enter your 4 digit postcode'
);

$.validator.addMethod(
	'phone',
	(value: string) => {
		return value.length >= 10 && value.length <= 12 && !/[^\d() pP+*#]$/.test(value);
	},
	() => 'Please enter a valid phone number'
);

$.validator.addMethod(
	'email',
	(value: string) => {
		return /^.+@.+\..+$/.test(value);
	},
	() => 'Please enter a valid email address'
);

$.validator.addMethod(
	'optionalEmail',
	(value: string) => {
		if (!value) {
			return true;
		}
		return /^.+@.+\..+$/.test(value);
	},
	() => 'Please enter a valid email address'
);

$.validator.addMethod(
	'optionalPhone',
	(value: string) => {
		if (!value) {
			return true;
		}
		return value.length >= 10 && value.length <= 12 && !/[^\d() pP+*#]$/.test(value);
	},
	() => 'Please enter a valid phone number'
);

$.validator.addMethod(
	'optionalPostcode',
	(value: string) => {
		if (!value) {
			return true;
		}
		return /^\d{4}$/.test(value);
	},
	() => 'Please enter your 4 digit postcode'
);


$.validator.addMethod(
	'optionalWebsite',
	(value: string) => {
		if (!value) {
			return true;
		}
		return /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~]*)*(#[\w\-]*)?(\?.*)?/.test(value);
	},
	() => 'Please enter a valid url'
);

$.validator.addMethod(
	'website',
	(value: string) => {
		return /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~]*)*(#[\w\-]*)?(\?.*)?/.test(value);
	},
	() => 'Please enter a valid url'
);
